<template>
  <div style="height: 100%; padding: 10px">
    <div style="text-align: center; font-size: 30px; margin-bottom: 30px">
      采购发票： {{ baseInfo.pur_no }}
    </div>
    <div>
      <el-row :gutter="24" style="margin-bottom: 20px">
        <el-col :span="24"
          >&nbsp;&nbsp;&nbsp;&nbsp;相关订单：{{ orderNoS }}
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin: 20px 0px">
        <el-col :span="8">采购类型：{{ baseInfo.pur_type }} </el-col>
        <el-col :span="8">下单日期：{{ baseInfo.order_time }} </el-col>
        <el-col :span="8">预期交货：{{ baseInfo.expected_time }} </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-bottom: 20px">
        <el-col :span="8"
          >&nbsp;&nbsp;&nbsp;&nbsp;供应公司：{{ baseInfo.spr_id }}
        </el-col>
        <el-col :span="16">公司地址：{{ baseInfo.spr_add }} </el-col>
      </el-row>
    </div>
    <div class="content">
      <el-table
        :data="dataSource"
        show-summary
        style="width: 100%; font-size: 12px"
        max-height="800px"
      >
        <el-table-column prop="pdt_no" label="产品编码" width="260" />
        <el-table-column prop="pdt_dep" label="产品描述" width="350" />
        <el-table-column prop="num" label="下单数量" width="100" />
        <el-table-column prop="price" label="采购单价" width="100" />
        <el-table-column prop="pur_total" label="小计" width="100" />
        <el-table-column prop="pdt_color" label="产品颜色" width="100" />
        <el-table-column prop="remark" label="备注" />
      </el-table>
    </div>
    <div>
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col> 采购备注：{{ baseInfo.remark }} </el-col>
      </el-row>
    </div>
  </div>
  <div
    style="
      position: fixed; /* 固定在视口 */
      bottom: 0; /* 贴底 */
      width: 100%; /* 占满宽度 */
      text-align: center; /* 文字居中 */
      padding: 5px 0;
      background-color: #f0f0f0;
      color: #333;
    "
  >
    <p>Copyright © 2025 GEEKID.COM</p>
    <p>All rights reserved.</p>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { printPurchaseOrder } from "@/network/showDetails.js";
import { useRoute } from "vue-router";
export default {
  components: {},
  setup() {
    const route = ref(useRoute());
    const state = reactive({
      dataSource: [],
      baseInfo: [],
      orderNoS: "",
    });
    const printInfo = route.value.query.arrData;
    const getList = () => {
      printPurchaseOrder({ data: printInfo }).then((res) => {
        if (res.code == 0) {
          state.orderNoS = res.data.orderNoS;
          state.baseInfo = res.data.baseInfo;
          state.dataSource = res.data.lists;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    onMounted(() => {
      getList();
    });
    return {
      ...toRefs(state),
    };
  },
};
</script>
